import { addDomainAndTokenToUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';

export interface IUnrulyDSP {
  id: number;
  nameDisplay: string;
  shortName: string;
  usersyncActive: boolean;
  usersyncUrl: string;
  secureUsersyncUrl: string;
  usersyncSpecifyRedir: boolean;
  usersyncDspMacro: string;
  allowGdprSync: boolean;
  iabVendorId: number;
  reportSecurityKey: string;
  settleMarginType: string;
  pricingModel: string;
  gpId: string;
  auditPriceMacro: string;
  auditExtraParam: string;
  customConnector: string;
  blockIbv: boolean;
  forwardPmp: boolean;
  filterRequireDeviceIdMask: number;
  filterDomain: string;
  filterSiteId: string;
  filterAppId: string;
  filterPubId: string;
  filterAppBundle: string;
  filterSourceRatingList: string;
  filterSiteAdstxt: number;
  filterAppAdstxt: number;
  ipv6Support: boolean;
  priceMacro: string;
  kafkaTopic: string;
  includeSupplyChain: number;
  pubDealSupport: boolean;
  logResponse: boolean;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface IUnrulyPackage {
  packageId: number;
  publisher: string;
  publisherDeals: any;
  placements: number[];
  status: string;
  description: string;
  notes: string;
  filterCountry: string;
  filterCountryList: string;
  filterZipCode: string;
  filterZipCodeList: string;
  filterDma: string;
  filterDmaList: string;
  filterRegion: string;
  filterRegionList: string;
  filterImpType: string;
  filterDeviceType: string;
  filterSite: string;
  filterApp: string;
  filterPreroll: string;
  filterMidroll: string;
  filterPostroll: string;
  filterViewabilityPercent: number;
  filterCtrPercent: number;
  filterVcrPercent: number;
  debugEnd: string;
  deletedAt: string;
  updatedAt: string;
  createdAt: string;
}

// |------------------ Unruly Proxy API CALLS ------------------|

export async function getUnrulyPackages(publisherID: string): Promise<IUnrulyPackage[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/deal/rhythmone/packages`);
  return await restGet<any>(reqUrl, {}).then((val: IHttpResponse<any>) => {
    return val.parsedBody as IUnrulyPackage[];
  });
}

export async function getUnrulyDSPs(publisherID: string): Promise<IUnrulyDSP[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/deal/rhythmone/dsps`);
  return await restGet<any>(reqUrl, {}).then((val: IHttpResponse<any>) => {
    return val.parsedBody as IUnrulyDSP[];
  });
}
